import styled, { css } from 'styled-components';
import media from 'styled-media-query';
const HeadingModifiers = {
    h1: (theme) => css `
    ${media.lessThan('medium') `
        font-size: ${theme.font.size.lg};
        font-weight: bold;
    `}
    ${media.between('medium', 'large') `
    font-size:${theme.font.size.xxl};
        font-weight: bold;
    `}
    ${media.greaterThan('large') `
    font-size:${theme.font.size.xxl};
    line-height: 72px;
    `}
  `,
    h2: (theme) => css `
    ${media.lessThan('medium') `
    font-size: ${theme.font.size.xl};
        font-weight: bold;
    `}
    ${media.between('medium', 'large') `
    font-size:${theme.font.size.xl};
        font-weight: bold;
    `}
    ${media.greaterThan('medium') `
    font-size:${theme.font.size.xxl};
    `}
  `,
    h3: (theme) => css `
    ${media.lessThan('medium') `
    font-size: ${theme.font.size.sm};
    font-weight: ${theme.font.weight.bold};
    line-height: ${theme.spacing.stack.xxs};  
    `}
    ${media.between('medium', 'large') `
    font-size:${theme.font.size.lg};
    font-weight: ${theme.font.weight.bold};
    line-height: ${theme.spacing.stack.md};
    `}
    ${media.greaterThan('medium') `
    font-size:${theme.font.size.lg};
    font-weight: ${theme.font.weight.bold};
    line-height: ${theme.spacing.stack.md};
    `}
  `,
    h4: (theme) => css `
    ${media.lessThan('medium') `
        font-size:${theme.font.size.md};
        font-weight: bold;
    `}
    ${media.between('medium', 'large') `
    font-size:${theme.font.size.md};
        font-weight: bold;
    `} 
    ${media.greaterThan('medium') `
        font-size:${theme.font.size.xxl};
        line-height: 72px;
    `}
  `,
    h5: (theme) => css `
    ${media.lessThan('medium') `
    font-size:${theme.font.size.sm};
        font-weight: bold;
    `}
    ${media.between('medium', 'large') `
    font-size:${theme.font.size.md};
        font-weight: bold;
    `}
    ${media.greaterThan('medium') `
    font-size:${theme.font.size.md};
    `}
  `
};
export const Heading = styled('h1').attrs(({ variant }) => ({
    as: `${variant}`
})) `
  ${({ theme, variant }) => css `
    ${HeadingModifiers[variant](theme)}
    color: ${theme.color.base.nth1};
  `}
`;
//# sourceMappingURL=Heading.js.map